import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import Modal from 'react-bootstrap/Modal'
import { connect } from 'react-redux'
import { isHtmlContentEmpty } from '../../utils/helper'

function ModalTerm(props) {
    const { setShow, show, partnerDetails, facilityId } = props
    const handleClose = () => setShow(false)
    let selectedFacility = partnerDetails?.facilities?.filter((v) => v.id == facilityId)
    let term_condition =
        selectedFacility?.[0]?.facility_configuration?.terms_condition_content
            ? selectedFacility[0].facility_configuration.terms_condition_content
            : partnerDetails?.brand_setting?.terms_condition_content
                ? partnerDetails.brand_setting.terms_condition_content
                : partnerDetails?.partner_details?.brand_setting?.terms_condition_content
                    ? partnerDetails.partner_details.brand_setting.terms_condition_content
                    : ''

    // Determine if "term_condition" is empty, even if it has html tags/empty tags
    const isEmpty = isHtmlContentEmpty(term_condition)

    const displayContent = !isEmpty
        ? <div dangerouslySetInnerHTML={{ __html: term_condition }} />
        : <div>N/A</div>

    return (
        <Modal show={show} size='lg' scrollable='true' onHide={handleClose}>
            <Modal.Header closeButton> <Modal.Title>Terms &amp; Conditions</Modal.Title> </Modal.Header>
            <Modal.Body>
                <div className="mb-3">
                    {displayContent}
                    <button type='button' onClick={handleClose} className='btn btn-outline-dark mt-3' name='Close' role='button' >Close</button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

ModalTerm.propTypes = {
    dispatch: PropTypes.func,
    setShow: PropTypes.func,
    show: PropTypes.bool,
    partnerDetails: PropTypes.object,
    facilityId: PropTypes.string
}

ModalTerm.defaulProps = {
    dispatch: noop,
    setShow: noop,
    show: false,
    partnerDetails: {},
    facilityId: ''
}

function mapStateToProps({ userDetailsReducer }) {
    return {
        loader: userDetailsReducer?.loader,
        loaderSms: userDetailsReducer?.loaderSms,
        loaderDownload: userDetailsReducer?.loaderDownload,
    }
}
export default connect(mapStateToProps)(ModalTerm)